import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './component/footer/footer.component';
import { NavigationComponent } from './component/navigation/navigation.component';
import { TopbarComponent } from './component/topbar/topbar.component';

@NgModule({
  declarations: [
    TopbarComponent,
    NavigationComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    TopbarComponent,
    NavigationComponent,
    FooterComponent,
  ],
})
export class LayoutModule { }
